module.exports = __webpack_public_path__ + "static/media/congrats.60f9bc84.svg";